/** Figma definition: [link](https://www.figma.com/design/2fEScGXkSAxlZaLBCm4ki2/%F0%9F%92%A0-Official-Design-Library?node-id=3232-2521&m=dev). */
export const fontWeight = {
  regular: 400,
  /** We don't have `bold` text in the app; "bold" text uses medium font weight. */
  medium: 500,
} as const;
